import React from "react";
import { connect } from "react-redux";
import { PropTypes } from "prop-types";
import get from "lodash/get";
import "./collection-name.module.css";
import { CustomLink } from "../../custom-link";

/* Remove all the functions with 'dupe' in them after API update implementation by platform - https://github.com/quintype/itsman/issues/1450 */

function sectionPageRouteDupe(route, params) {
  return {
    pageType: "section-page",
    exact: true,
    sectionPath: route ? `/${route}` : route,
    params: params
  };
}

export function generateSectionPageRoutesDupe(config, opts = {}, currentSection = {}) {
  const sectionsById = config.sections.reduce((acc, section) => {
    acc[section.id] = section;
    return acc;
  }, {});
  const sectionId = get(currentSection, ["metadata", "section", 0, "id"]) || currentSection.id;
  const requiredSection = config.sections.find(section => section.id === sectionId) || {};
  return [requiredSection].flatMap(section => generateSectionPageRouteDupe(section, sectionsById, opts));
}

function addSectionPrefixDupe(route, params) {
  return sectionPageRouteDupe(`section/${route}`, params);
}

export function generateSectionPageRouteDupe(section, sectionsById, opts) {
  const params = { sectionId: section.id };
  if (section.collection) params.collectionSlug = section.collection.slug;

  let slug = section.slug;
  if (section["parent-id"]) {
    let currentSection = section;
    let depth = 0;
    while (currentSection["parent-id"] && depth++ < 5) {
      currentSection = sectionsById[currentSection["parent-id"]] || { slug: "invalid" };
      slug = `${currentSection.slug}/${slug}`;
    }
  }

  let routes = [];
  if (section["parent-id"] && opts.secWithoutParentPrefix) routes = [section.slug, slug];
  else routes = [slug];

  if (opts.addSectionPrefix)
    routes = routes.flatMap(route => [sectionPageRouteDupe(route, params), addSectionPrefixDupe(route, params)]);
  else routes = routes.flatMap(route => [sectionPageRouteDupe(route, params)]);

  return routes;
}

const retrieveRowTitleStyle = props => {
  const aheadTitleStyle = get(props, ["config", "theme-attributes", "row-title-style"], "default");
  const rowTitleStyle = get(
    props,
    ["config", "pagebuilder-config", "general", "rows", "titleStyle", "type"],
    aheadTitleStyle
  );
  return rowTitleStyle;
};

function getTemplate(props) {
  const isSection = isSectionCollection();
  function isSectionCollection() {
    const template = get(props, ["section", "template"]);
    const section = get(props, ["section", "metadata", "section"], props.section);
    return template !== "collection" && template !== "default" && section;
  }

  const subSection = retrieveRowTitleStyle(props) === "style-1" ? "border-unset" : "";
  const underlineColor = get(
    props,
    ["config", "pagebuilder-config", "general", "rows", "titleStyle", "underLineColor"],
    "var(--primaryColor)"
  );

  const borderStyle =
    retrieveRowTitleStyle(props) === "default"
      ? { borderBottom: `2px solid ${underlineColor}` }
      : { borderBottom: `none` };
  if (isSection) {
    const sectionPageRoutes = generateSectionPageRoutesDupe(props.config, {}, props.section);
    const sectionPath = get(sectionPageRoutes, [0, "sectionPath"]);
    if (sectionPath) {
      const mountAtPrefix = props.config.mountAt || "";
      return (
        <div styleName={`sub-section ${subSection}`} style={borderStyle}>
          <CustomLink href={`${mountAtPrefix}${sectionPath}`} style={{ color: props.textColor }}>
            {props.name}
          </CustomLink>
        </div>
      );
    }
    return (
      <div styleName={`sub-section ${subSection}`} style={borderStyle}>
        {props.name}
      </div>
    );
  }
  if (get(props, ["section", "slug"])) {
    return (
      <div styleName={`sub-section ${subSection}`} style={borderStyle}>
        <CustomLink href={`/collection/${get(props, ["section", "slug"])}`} style={{ color: props.textColor }}>
          {props.name}
        </CustomLink>
      </div>
    );
  }

  return (
    <div styleName={`sub-section ${subSection}`} style={borderStyle}>
      {props.name}
    </div>
  );
}

const CollectionNameBase = props => {
  const rowTitleStyle = retrieveRowTitleStyle(props);
  function getRowTitleStyle(rowTitleStyle) {
    switch (rowTitleStyle) {
      case "white":
        return "section--white";
      case "style-1":
        return "section--style1";
      default:
        return "section--default";
    }
  }

  return (
    <div styleName={`section ${getRowTitleStyle(rowTitleStyle)}`} data-section-name="true">
      {getTemplate(props)}
    </div>
  );
};
CollectionNameBase.propTypes = {
  collectionTemplate: PropTypes.oneOf(["default", "white", "style-1"])
};

getTemplate.propTypes = {
  sectionToColor: PropTypes.func,
  section: PropTypes.Object,
  inlineStyle: PropTypes.Object,
  config: PropTypes.Object,
  name: PropTypes.string,
  textColor: PropTypes.string
};

function mapStateToProps(state) {
  return {
    config: get(state, ["qt", "config"], {})
  };
}

export const CollectionName = connect(mapStateToProps)(CollectionNameBase);
